var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-ccontent"},[(!_vm.$route.meta.external)?[_c('HeadPage')]:_vm._e(),_c('transition',[_c('router-view')],1),_c('BottomPage'),_c('errTips')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }